// extracted by mini-css-extract-plugin
export default {"err_msg":"verification_err_msg__e8jdY","success_msg":"verification_success_msg__41Uzi"};